// Section 13 safety and deterrence at a glance: safety points with their breakdown (guards,
// watch posts, a manned palisade), what the settlement needs, whether the safety need is met
// and why not, and deterrence with the factor it puts on everyone's chance of crime. Props only.
import type { JusticeVM } from '../../../viewModels/justice';
import { oneDecimal, percent, times } from '../../format';
import { justiceText as t } from '../../text/en';
import { Num } from '../../tooltip/num';

export function SafetySummary({ vm }: { vm: JusticeVM }) {
  const s = vm.safety;
  const d = vm.deterrence;
  return (
    <section class="justice__section" aria-labelledby="justice-safety-title">
      <h4 id="justice-safety-title">{t.safetyTitle}</h4>
      <dl class="justice-facts">
        <dt>{t.safetyPoints}</dt>
        <dd>
          <Num value={s.points} format="one" factors={s.breakdown} label={t.safetyPoints} />
          <span class="justice-muted"> {t.safetyNeeded(oneDecimal(s.needed))}</span>
        </dd>
        <dt>{t.deterrence}</dt>
        <dd>
          <Num value={d.strength} format="times" factors={d.factors} label={t.deterrence} />
        </dd>
        <dt>{t.crimeFactor}</dt>
        <dd>
          <span class="num">{times(d.crimeFactor)}</span>
          <span class="justice-muted"> {t.crimeFactorHint}</span>
        </dd>
      </dl>
      <p>{t.guardsOnDuty(s.guardsOnDuty)}</p>
      <p class={s.need >= 1 ? '' : 'justice-note'} role="status">
        {s.need >= 1 ? t.safetyMet : t.safetyShort(percent(s.need))}
      </p>
      {s.undetectedKilling && <p class="justice-note">{t.undetectedKilling}</p>}
      {s.raidLoss && <p class="justice-note">{t.raidLoss}</p>}
    </section>
  );
}
